module.exports = __webpack_public_path__ + "img/facial-recognition.b5e1ae38.svg";